
export class Constants {
    static EmptyGuid = "00000000-0000-0000-0000-000000000000";
}

export const DefaultListParameters = {
    viewRecordsByPage: 20,
    drawerRecordsByPage: 20
};


export const WidePicture: ImageDimensions = {
    width: 210,
    height: 118,
};

export const PortraitPicture: ImageDimensions = {
    width: 89,
    height: 118,
};

export const SquarePicture: ImageDimensions = {
    width: 118,
    height: 118,
};

export const EditorPicture: ImageDimensions = {
    width: 256,
    height: 256,
};

export const ChartJsHeight = "30vh";

export const ChartJsOptions = {
    maintainAspectRatio: false
};